import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InstructionNodeModel } from './symbols';

@Injectable()
export class InstructionsService {
  private readonly api = '/api/instructions';

  constructor(private http: HttpClient) {}

  getTree(): Observable<InstructionNodeModel[]> {
    return this.http.get<InstructionNodeModel[]>(this.api);
  }

  createDirectory(name: string, parentId?: string): Observable<InstructionNodeModel> {
    return this.http.post<InstructionNodeModel>(`${this.api}/directory`, { name, parentId });
  }

  uploadFile(directoryId: string, file: File): Observable<InstructionNodeModel> {
    const form = new FormData();
    form.append('file', file);
    return this.http.post<InstructionNodeModel>(`${this.api}/${directoryId}/file`, form);
  }

  renameNode(id: string, name: string): Observable<InstructionNodeModel> {
    return this.http.patch<InstructionNodeModel>(`${this.api}/${id}/rename`, { name });
  }

  deleteNode(id: string): Observable<void> {
    return this.http.delete<void>(`${this.api}/${id}`);
  }

  getFileUrl(id: string): string {
    return `${this.api}/file/${id}`;
  }
}
